<template>
  <div id="app">
    <!-- <Header v-if="hideHeader == -1"></Header> -->
    <HeaderNew v-if="hideHeader == -1"></HeaderNew>
    <router-view />
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      hideHeader: "",
    };
  },
  created() {
    this.hideHeader =
      window.location.hash.indexOf("privacyAct") ||
      window.location.hash.indexOf("PrivacyPolicy");
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue